<section class="about-hero-section">
    <div class="container">
        <div class="row">
            <div class="col-12 hero-content-wrapper">
                <h1 class="hero-title">Discover the Direkt Difference</h1>
                <p class="hero-subtitle">Making property transactions seamless, transparent, and direct.</p>
            </div>
        </div>
    </div>
</section>

<section class="about-content-section py-5">
    <div class="container">
        
        <div class="row align-items-center mb-5 justify-content-center">
            
            <div class="col-lg-8">
                <h2 class="content-heading text-center">About Direkt.ae: Our Mission</h2>
                <p class="lead text-primary-color text-center mb-4">
                    Buying a property is one of the most major decisions in an individual’s journey of life. Direkt.ae is born out of the notion that the power of deciding and driving that decision should vest entirely with the individuals who are directly party to it.
                </p>
                <p class="text-secondary-color text-justify">
                    We have come out with an objective and completely agnostic platform, which connects the buyer to the seller, the tenant to the landlord, the buyer to the developer, all just **directly**, with no intermediary or middlemen in between. We believe that this creates a level playing field for all the users, not to mention the substantial cost savings that the direct communication entails.
                </p>
            </div>
        </div>

        <div class="row mt-5 pt-5">
            <div class="col-12">
                <h3 class="text-center section-subheading">Our Vision & Value Proposition</h3>
            </div>
        </div>
        
        <div class="row feature-row">
            
            <div class="col-md-6 feature-card">
                <div class="icon-box">
                    <i class="fas fa-handshake"></i> </div>
                <h4 class="feature-title">Direct Connection & Transparency</h4>
                <p class="text-secondary-color">
                    Direkt.ae aims to organically evolve as the one-stop shop to e-meet all the direct stakeholders in any property transaction, making it a seamless and transparent process, end to end. We will always be the ‘buy-side client-centric’ team, ensuring the journey is an experience, not a cumbersome navigation.
                </p>
            </div>
            
            <div class="col-md-6 feature-card">
                <div class="icon-box">
                    <i class="fas fa-money-bill-wave"></i> </div>
                <h4 class="feature-title">Substantial Cost Savings</h4>
                <p class="text-secondary-color">
                    Bypassing traditional intermediaries allows for direct communication, which entails substantial cost savings for both the buyer and the seller/developer. Simple, efficient, and cost-effective. Direkt.ae will always be at the client’s disposal.
                </p>
            </div>

            <div class="col-12 mt-5 text-center final-statement">
                <p class="lead fw-bold text-primary-color">
                    Formed out of a clarion mission by a team of dedicated professionals to make matters simple & easy. <br />Direkt.ae will be on a constant endeavor to make 'simple, simpler'.
                </p>
            </div>
            
        </div>
    </div>
</section>